import { Row, Spin, Typography, Col } from "antd";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import HTTPClient from "../../../utils/HTTPClient";
import { useTranslation } from "react-i18next";
import { CreateFromAiCard } from "./CreateFromAiCard";
import { CreateFromTemplateCard } from "./CreateFromTemplateCard";

const Create = () => {
    const [loading, setLoading] = useState(false);
    const [showBuyModal, setShowBuyModal] = useState(false);
    
    const { t } = useTranslation();

    const fetch = async () => {
        setLoading(true);
        let response = await HTTPClient.get("/builder/");
        if (response.status === 203) {
            await HTTPClient.post("/builder/start_builder");
        }
        setLoading(false);
    };

    useEffect(() => {
        fetch();
    }, []);

    const isLargeScreen = useMediaQuery({
        query: "(min-width: 771px)",
    });

    if (loading) return <Spin size="large" />;

    return (
        <>
            <Row style={{ padding: isLargeScreen ? "20px 50px" : "10px 10px" }}>
                <Row>
                    <Typography.Text style={{ fontSize: "36px", fontWeight: "bold" }}>
                        {t("builder.create.title")}
                    </Typography.Text>
                </Row>
                <Row style={{ width: "100%", marginTop: "10px" }}>
                    <Typography.Text>{t("builder.create.subtitle")}</Typography.Text>
                </Row>
                <Row
                    style={{
                        padding: isLargeScreen ? "20px 50px" : "10px 10px",
                        display: "flex",
                        justifyContent: "space-between",
                    }}>
                    <Col xs={24} s={24} md={24} lg={11} xl={11}>
                        <CreateFromTemplateCard />
                    </Col>
                    <Col xs={24} s={24} md={24} lg={11} xl={11}>
                        <CreateFromAiCard setLoading={ (status) => setLoading(status) } showBuyModal={showBuyModal} setShowBuyModal={ (status) => setShowBuyModal(status) }/>
                    </Col>
                </Row>
            </Row>
        </>
    );
};

export { Create };
